<script setup lang="ts">
const baseAnimationClass = `transition duration-300`
</script>

<template>
    <Transition mode="out-in" :enter-active-class="baseAnimationClass" enter-from-class="opacity-0"
        enter-to-class="opacity-100" :leave-active-class="baseAnimationClass" leave-from-class="opacity-100"
        leave-to-class="opacity-0">
        <slot />
    </Transition>
</template>
